import classNames from 'classnames'
import { PropsWithChildren } from 'react'

import { RenderWhen } from 'cng-common/components/renderWhen'

import { IP360CardProps } from './models/IP360CardProps'

import styles from './P360Card.module.scss'

export const P360Card = ({
  children,
  bodyClassName,
  className,
  notification,
  header,
  headerRightContent,
  fullHeight,
  disabled,
}: PropsWithChildren<IP360CardProps>) => {
  return (
    <div
      className={classNames(
        { [styles.root]: !disabled },
        { [styles['root--fullHeight']]: fullHeight },
        className || ''
      )}
    >
      {notification ? (
        <div
          className={classNames(styles.notification, {
            [styles[`notification--${notification.type}`]]: notification.type,
          })}
        >
          {notification.content}
        </div>
      ) : null}
      <RenderWhen condition={!!header || !!headerRightContent}>
        <div className={styles.headerRow}>
          {header || headerRightContent ? <div className={styles.header}>{header}</div> : null}
          {headerRightContent}
        </div>
      </RenderWhen>
      <div className={classNames(styles.body, bodyClassName)}>{children}</div>
    </div>
  )
}
